<style>
#loginSettingsModal .v--modal-box.v--modal {
  min-width: 430px !important;
  min-height: 240px !important;
}
#loginSettingsModal .v-text-field__slot label,
#loginSettingsModal .v-text-field__slot input {
  font-size: 12px;
}
#loginSettingsModal .v-messages__message {
  line-height: 1.2;
}
</style>

<template>
  <div class="wrapper">
    <Modal
      modalName="loginSettingsModal"
      title="Ustawienia logowania"
      module="login_settings"
      :buttons="[]"
      :editing="editing"
      @closed="closed()"
      @editingStart="startEditing()"
      @editingSave="saveEditing()"
      @editingCancel="cancelEditing()"
      @opened="getSettings()"
    >
      <v-layout row wrap>
        <v-flex xs12>
          <p>W przypadku braku ograniczeń prób logowania do systemu lub czasu życia hasła należy zostawić odpowiadające im pola puste.</p>
        </v-flex>
      </v-layout>
      <div v-if="!editing">
        <v-layout
          row
          wrap
          justify-space-between
        >
          <v-flex xs5>
            <v-text-field
              readonly
              height="16"
              v-model="settings.MAX_FAILED_LOGINS"
              label="Liczba prób logowania"
            ></v-text-field>
          </v-flex>
          <v-flex xs5>
            <v-text-field
              readonly
              height="16"
              v-model="settings.PASSWORD_EXPIRE_DAYS"
              label="Czas życia hasła (dni)"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-text-field
              readonly
              height="16"
              v-model="settings.PASSWORD_RECOVERY_VALIDITY_HOURS"
              label="Czas działania linku z przypomnieniem hasła (godziny)"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-layout
            row
            wrap
            justify-space-between
          >
            <v-flex xs5>
              <v-text-field
                height="16"
                v-model="settingsCopy.MAX_FAILED_LOGINS"
                label="Liczba prób logowania"
              ></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-text-field
                height="16"
                v-model="settingsCopy.PASSWORD_EXPIRE_DAYS"
                label="Czas życia hasła (dni)"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout style="margin-top: 10px;">
            <v-flex xs12>
              <v-text-field
                height="16"
                v-model="settingsCopy.PASSWORD_RECOVERY_VALIDITY_HOURS"
                :rules="hoursRules"
                label="Czas działania linku z przypomnieniem hasła (godziny)"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: vm => ({
    valid: false,
    editing: false,
    settingsCopy: {},
    hoursRules: [
      (v) => !!v || 'Wartość wymagana',
      (v) => /^([0-9]*$)/.test(v) || 'Podaj liczbę' // /^(2[0-4]|1[0-9]|[1-9])$/.test(v) || 'Czas działania linku z przypomnieniem hasła musi wynosić 1-24 godzin'
    ],
  }),
  computed: {
    settings() {
      return this.$store.getters.getSettings;
    }
  },
  methods: {
    startEditing() {
      this.settingsCopy = JSON.parse(JSON.stringify(this.settings));
      this.editing = true;
    },
    saveEditing() {
      let num = 0;
      if (this.settingsCopy.MAX_FAILED_LOGINS == '') {
        this.$set(this.settingsCopy, 'MAX_FAILED_LOGINS', num.toString())
      }
      if (this.settingsCopy.PASSWORD_EXPIRE_DAYS == '') {
        this.$set(this.settingsCopy, 'PASSWORD_EXPIRE_DAYS', num.toString())
      }
      this.$store.dispatch("changeSettings", this.settingsCopy).then(success => {
        if(success) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie edytowano ustawienia logowania"
          );
          this.editing = false;
          this.$store.commit("setSettings", this.settingsCopy)
          this.$modal.hide("loginSettingsModal")
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas edytowania ustawień logowania wystąpił błąd"
          );
        }
      })
    },
    cancelEditing() {
      this.editing = false;
    },
    async getSettings() {
      await this.$store.dispatch("getSettings");
      if (this.settings.MAX_FAILED_LOGINS == 0) {
        this.$set(this.settings, 'MAX_FAILED_LOGINS', '')
      }
      if (this.settings.PASSWORD_EXPIRE_DAYS == 0) {
        this.$set(this.settings, 'PASSWORD_EXPIRE_DAYS', '')
      }
    },
    closed() {
      this.$store.commit("setSettings", {})
      this.settingsCopy = {};
      this.editing = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/loginSettings/LoginSettings.vue